import React, { useState, useEffect } from "react";
import { AppBar, Toolbar, Typography } from "@material-ui/core";
import Logo from "../images/logo.webp";
const Header = (props) => {
  return (
    <div>
      <AppBar
        position="static"
        color="default"
        style={{ backgroundColor: "#FFFFFF", boxShadow: "none", marginTop: 24 }}
      >
        <Toolbar>
          <img src={Logo} />
        </Toolbar>
      </AppBar>
    </div>
  );
};

export default Header;
